import React from 'react';
import { useTranslation } from 'next-i18next';
import './events.quiz-build-form';
import { trackEvent } from '@zep/logger/tracking';
import { GearIcon, PaperIcon } from '@/icons';
import { TabsWithSlider } from '@/ui_v3/components/tabs';
import { cn } from '@/utils/tailwind.util';
import { useBuildFormContext } from '../form/schema';
import { type BuildStep } from './BuildHeader';
import { getBuildFormTrackPayload } from './getBuildFormTrackPayload';
export const BuildStepToggleTab = ({
  currentStep,
  onBuildStepChange
}: {
  currentStep: BuildStep;
  onBuildStepChange: (step: BuildStep) => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    getValues
  } = useBuildFormContext();
  const options: {
    value: BuildStep;
    label: React.ReactNode;
  }[] = [{
    value: 'quiz' as BuildStep,
    label: <span onClick={() => {
      trackEvent('click_quiz_tab', getBuildFormTrackPayload(getValues()));
    }}>
          <PaperIcon className="group-data-[state=active]:text-alternative" size={'2xs'} />
          {t('build:build.quiz')}
        </span>
  }, {
    value: 'settings' as BuildStep,
    label: <span onClick={() => {
      trackEvent('click_settings_tab', getBuildFormTrackPayload(getValues()));
    }}>
          <GearIcon className="group-data-[state=active]:text-alternative" size={'2xs'} />
          {t('build:build.settings')}
        </span>
  }];
  return <TabsWithSlider isFull size="sm" value={currentStep} onValueChange={onBuildStepChange} options={options} className="h-[44px] w-[270px] gap-0 rounded-sm border border-alternative bg-alternative p-[3px] tablet-lg:w-[300px]" tabTriggerProps={{
    asChild: true,
    className: cn('group', 'rounded-sm bg-clip-content flex-1 h-full text-body-sm-semibold text-assistive flex justify-center items-center gap-3xs', 'data-[state=active]:hover:bg-transparent data-[state=active]:text-default', 'data-[state=inactive]:hover:bg-opacity-black-1 data-[state=inactive]:hover:text-alternative')
  }} data-sentry-element="TabsWithSlider" data-sentry-component="BuildStepToggleTab" data-sentry-source-file="BuildStepToggleTab.tsx" />;
};